import PropTypes from 'prop-types';

export const fileUrlArrayShape = PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    created: PropTypes.string.isRequired,
});